<template>
  <el-drawer
    :visible.sync="visible"
    direction="btt"
    custom-class="custom-drawer"
    :with-header="false"
  >
    <div class="camp-container">
      <div class="hd">
        <div class="title">{{ $t("lang.chooseCamp") }}</div>
      </div>
      <div class="bd">
        <div class="price">
          <div class="item-title">{{ $t("lang.ticketPrice") }}:</div>
          <div class="item-value">
            <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
            <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
            <img v-else-if="chain == 'BTY'" :src="require('@/assets/img/ranking/BTY-logo.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>

            <div class="num">{{ Price }}</div>
          </div>
        </div>
        <div class="price balance-block">
          <div class="item-title wallet-subtitle-row">
            <span>{{ $t('lang.VoteWalletBalanceTitle') }}</span>
            <el-button
              type="text"
              class="wallet-refresh-btn"
              icon="el-icon-refresh"
              :loading="walletRefreshing"
              :title="$t('lang.VoteBalanceRefresh')"
              @click="refreshWalletBalance"
            />
          </div>
          <div class="item-value">
            <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
            <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
            <img v-else-if="chain == 'BTY'" :src="require('@/assets/img/ranking/BTY-logo.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
            <div class="num">{{ balanceTotal }}</div>
          </div>
        </div>
        <div class="choose-container">
          <div
            class="choose-item item-smile"
            @click="activeSmile"
            :class="{ active: isSmile }"
          ></div>
          <div class="choose-or">{{ $t("lang.or") }}</div>
          <div
            class="choose-item item-angry"
            @click="activeAngry"
            :class="{ active: isAngry }"
          ></div>
         
        </div>
        <div style="padding: 20px 0; width: 70%; margin: 0 auto;">
				   	<el-input :placeholder="$t('lang.PleasePassword')" v-model="password" show-password></el-input>
			   	</div>
        <div class="choose-actions">
          <div class="btn btn-rounded btn-block btn-nft" @click="submit">
            {{ $t("lang.Confirm") }}
          </div>
        </div>
      </div>
      <!-- 失败弹窗 -->
      <Fail ref="failed"></Fail>
    </div>
  </el-drawer>
</template>
<script>
import ad from "@/utils/web3Helper";
import Fail from "./Failed.vue";
import {votePrice, BASE_GLOB_API} from "@/config.js"
import request from "../../../services/request";
import { axiosGet } from '@/api/api';
import {
	clearWalletInfoCache,
	getBtPlatformIdFromSelectedPlatform,
	hasAuthToken,
	readWalletInfoCache,
	writeWalletInfoCache,
} from "@/utils/walletInfoCache";

export default {
  name: "campDrawer",
  data() {
    return {
      chain: "",
      visible: false,
      typa: 0,
      isSmile: false,
      isAngry: false,
      item:{},
      Price:0,
      password:'',
      balanceTotal: '--',
      walletRefreshing: false,
    };
  },
  components: { Fail },
  computed: {
    btPlatformId() {
      return getBtPlatformIdFromSelectedPlatform();
    },
  },
  created() {
    let plat = JSON.parse( sessionStorage.getItem("selectedPlatform"));
    console.log("plat", plat);
    this.chain = plat.shortName;
    this.Price = plat.vote_price
  },
  mounted() {},
  methods: {
    openDialog(item) {
      // if (!TokenID.id || TokenID.id == "") return;
      this.syncPlatformFromSession();
      this.item = item;
      this.visible = true;
      this.loadWalletBalanceFromCacheOrFetch();
    },
    syncPlatformFromSession() {
      try {
        const raw = sessionStorage.getItem("selectedPlatform");
        if (!raw) return;
        const plat = JSON.parse(raw);
        if (plat.shortName) this.chain = plat.shortName;
        if (plat.vote_price != null && plat.vote_price !== "") this.Price = plat.vote_price;
      } catch (e) { /* ignore */ }
    },
    applyWalletResult(result) {
      if (!result) {
        this.balanceTotal = "--";
        return;
      }
      const surplus = result.surplusRevoCoin;
      const unit = result.btUnit || "";
      if (surplus === undefined || surplus === null || surplus === "") {
        this.balanceTotal = "--";
        return;
      }
      this.balanceTotal = `${surplus} ${unit}`.trim();
    },
    loadWalletBalanceFromCacheOrFetch() {
      if (!hasAuthToken()) {
        this.balanceTotal = this.$t("lang.VoteBalanceNeedLogin");
        return;
      }
      const pid = this.btPlatformId;
      if (!pid) {
        this.balanceTotal = "--";
        return;
      }
      const cached = readWalletInfoCache(pid);
      if (cached) {
        this.applyWalletResult(cached);
        return;
      }
      this.fetchWalletInfoFromApi(false);
    },
    refreshWalletBalance() {
      this.fetchWalletInfoFromApi(true);
    },
    fetchWalletInfoFromApi(manual) {
      if (!hasAuthToken()) {
        this.balanceTotal = this.$t("lang.VoteBalanceNeedLogin");
        return;
      }
      const pid = this.btPlatformId;
      if (!pid) {
        this.balanceTotal = "--";
        return;
      }
      this.walletRefreshing = true;
      const url = BASE_GLOB_API + "/kanban/wallet/info";
      axiosGet(url, { btPlatformId: pid }).then((res) => {
        this.walletRefreshing = false;
        const ok = res.code === 200 || res.code === "200";
        if (ok && res.result) {
          writeWalletInfoCache(pid, res.result);
          this.applyWalletResult(res.result);
        } else {
          if (manual) this.$message.error(res.message || this.$t("lang.failed"));
          this.balanceTotal = "--";
        }
      }).catch(() => {
        this.walletRefreshing = false;
        this.balanceTotal = "--";
      });
    },
    activeSmile() {
      if (this.isSmile == false) {
        this.isSmile = true;
        this.isAngry = false;
        this.typa = 1;
      } else {
        this.isSmile = false;
      }
    },
    activeAngry() {
      if (this.isAngry == false) {
        this.isAngry = true;
        this.isSmile = false;
        this.typa = 2;
      } else {
        this.isAngry = false;
      }
    },
    submit() {
      if (this.password.length == 0) {
        	this.$message.error(this.$t("lang.PleasePassword"));
	        return;
	     }
      let that = this;
      var para = {
				game_id: this.item.game_id,
				choose:this.typa,
        payPassword:this.password
			};
        request.getVote(para).then((res) => {
            if (res.code == "200") {
              clearWalletInfoCache(that.btPlatformId);
              that.visible =false;
              that.$emit('srcFail');
              that.password =''
              that.$message.success(res.message);
          }else {
              that.password =''
              that.$message.error(res.message);
           }
          }).catch((err) => {
             that.password =''
              that.$message.error(err.message);
          });
      // var _this = this;
      // if (this.typa != 1 && this.typa != 2) {
      //   this.$message({
      //     message:this.$t("lang.chooseCamp"),
      //     type: "error",
      //   });
      // }
      // ad.vote(
      //   this.TokenID,
      //   this.Price,
      //   this.typa,
      //   (hash) => {
      //     console.log("vote.success", hash);
      //     _this.visible = false;
      //     _this.$emit("updata",{hash,typa:this.typa})
      //   },
      //   (err) => {
      //     // _this.visible = false;
      //     this.$refs.failed.openDialog();
      //     console.log("sell.err", err);
      //   }
      // );
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.custom-drawer {
  height: 430px !important;
}
.camp-container {
  //height:400px;
  padding: 20px 0 0;
  .hd {
    padding: 0 0 10px;
    .title {
      font-size: 18px;
      text-align: center;
      line-height: 25px;
      color: #12022f;
    }
  }
  .bd {
    .price {
      text-align: center;
      .item-title {
        color: #12022f;
        line-height: 17px;
        padding-bottom: 8px;
      }
      .wallet-subtitle-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
      }
      .wallet-refresh-btn {
        padding: 0;
        font-size: 16px;
      }
      .item-value {
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-nft {
          background: url("~@/assets/img/nft.svg") no-repeat center
            center/contain;
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
        .num {
          font-size: 18px;
        }
      }
    }
  }
}
.choose-container {
  border: #979797 2px dashed;
  border-radius: 10px;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 30px;
  .choose-item {
    border: #dcdcdc 1px solid;
    border-radius: 10px;
    width: 76px;
    height: 76px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 60px 60px;
    cursor: pointer;
    transition: all 0.1s;
    &.item-smile {
      background-image: url("~@/assets/img/icon-sm-gray.svg");
    }
    &.item-angry {
      background-image: url("~@/assets/img/icon-k-gray.svg");
    }
    &.item-smile:hover,
    &.active.item-smile {
      border: #000 2px solid;
      background-image: url("~@/assets/img/icon-sm.svg");
    }
    &.item-angry:hover,
    &.active.item-angry {
      border: #000 2px solid;
      background-image: url("~@/assets/img/icon-k.svg");
    }
  }
  .choose-or {
    border: #ababab 1px solid;
    border-radius: 10em;
    padding: 3px 10px;
  }
}
.choose-actions {
  padding: 0 30px 10px;
}

.btn {
  display: inline-block;
  border: #ccc 1px solid;
  font-size: 16px;
  line-height: 26px;
  padding: 8px 20px;
  border-radius: 4px;
  color: #000;
  text-align: center;
  min-width: 130px;
  &.btn-rounded {
    border-radius: 10em;
  }
  &.btn-outline {
    background: transparent;
    &.btn-default {
      color: #fff;
    }
  }
  &.btn-block {
    display: block;
  }
  &.btn-nft {
    background: #ffdda9;
    border-color: #ffdda9;
    color: #000;
  }
}
</style>
